import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Button,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import QRCode from "react-qr-code";
import withRouter from "../../components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { get, post } from "../../api/axios";
import endpoints from "../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import Pass from "../../components/Common/Pass";
import passDesign1 from "../../../src/assets/peach.svg";
import passDesign2 from "../../../src/assets/green.svg";
import passDesign3 from "../../../src/assets/purple.svg";
import logo from "../../assets/images/elevated-logo.svg";
import login from "../../assets/images/newlogin.png";
import redeemPic from "../../assets/images/redeem.png";

const RedeemPass = (props) => {
  document.title = "Redeem Pass | Elevated";
  const [redeem, setRedeem] = useState([]);
  const [passId, setPassId] = useState("");
  const [gymId, setGymId] = useState("");

  const [code, setCode] = useState(true);
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleRedeem = async (passId, gymId) => {
    document.title = "Redeem Pass | Elevated - Admin Dashboard";
    if (!passId || !gymId) {
      toast.error("Both Pass Id and Gym Id are required.", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
      return;
    }

    const formData = new FormData();
    formData.append("passId", passId);
    formData.append("gymId", gymId);
    setLoading(true);
    try {
      await post(`${endpoints.publicRedeem}`, formData);
      toast.success("Thank you! Given pass has been redeemed successfully.", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });

      navigate("/login");
    } catch (error) {
      toast.error("Something went wrong. Please try again.", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
    } finally {
      setIsSubmitting(false);
      setLoading(false);
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      code: "",
    },
    validationSchema: Yup.object({
      code: Yup.string().required("Please enter pass QR code"),
    }),
    onSubmit: async (values) => {
      if (isSubmitting) return;
      setIsSubmitting(true);

      try {
        const response = await get(
          `${endpoints.publicRedeemDetail}?code=${values.code}`
        );

        if (response?.data?.data) {
          const passData = response.data.data;
          setRedeem(passData);
          console.log(passData);
          setPassId(passData.id);
          setGymId(passData.pass?.gym?.id);
          setCode(false);
        } else if (response?.data?.message === "Pass has been used up") {
          toast.error("Pass Limit Reached! You’ve already used this pass.", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        } else {
          console.log(response?.data?.message);
          toast.error(
            "Invalid pass code. Please check your code and try again.",
            {
              position: "bottom-center",
              theme: "colored",
              transition: Bounce,
            }
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error?.response || error);
        toast.error("Something went wrong. Please try again.", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  return (
    <>
      <div className=" account-pages bg-white">
        <Row className="d-flex align-items-center justify-content-center min-vh-100 g-0 px-3">
          <Col md="6" className="d-none d-xl-block">
            <div className="image-section">
              <img
                src={redeemPic}
                alt="Gym Equipment"
                className="object-fit-cover img-fluid w-100 rounded-5 "
                style={{ maxHeight: "96vh" }}
              />
            </div>
          </Col>
          <Col
            xs="12"
            md="6"
            className="d-flex align-items-center justify-content-center login-scroll"
          >
            <div className="">
              <Link
                to="/redeemPass"
                className="mb-3 d-block auth-logo mt-4 mt-md-4 mt-lg-4"
              >
                <img
                  src={logo}
                  alt="Elevated Iron Logo"
                  className="logo logo-light"
                />
              </Link>
            </div>
            <div className="pt-4 gap-0">
              <div className="login-container-responsive">
                <div className="login-form-wrapper">
                  <div className="logo text-center mb-4">
                    <img
                      src={logo}
                      height={"140px"}
                      alt="Elevated Iron Logo"
                      className="login-logo"
                    />
                  </div>
                  <h2 className="text-center mt-5 ff-sora fw-bold font-size-24 primary-black">
                    Redeem Pass
                  </h2>
                  <p className="text-center ff-sora font-size-16 secondary-black fw-normal">
                    Kindly enter the coupon below.
                  </p>

                  <Form
                    onSubmit={validation.handleSubmit}
                    className="login-form mx-2 mx-xl-0"
                  >
                    <FormGroup
                      style={{
                        width: "100%",
                        maxWidth: "548px",
                        height: "56px",
                      }}
                    >
                      <div className="d-flex">
                        <Input
                          type="text"
                          id="code"
                          placeholder="Redeem Pass Code"
                          className={`ff-sora fw-normal font-size-16 primary-black border-0 p-4 ${
                            validation.values.code ? "bg-change" : "bg-light"
                          }`}
                          value={validation.values.code}
                          onChange={validation.handleChange}
                          // onBlur={(e) => {
                          //   validation.handleBlur(e);
                          //   setIsFocusedCode(false);
                          // }}
                          // onFocus={() => setIsFocusedCode(true)}
                          invalid={
                            !!(
                              validation.touched.code && validation.errors.code
                            )
                          }
                          style={{
                            width: "100%",
                            maxWidth: "548px",
                            height: "56px",
                            backgroundColor: validation.values.code
                              ? "#EBF5F4"
                              : "#F5F5F5",
                            borderTopLeftRadius: "80px",
                            borderBottomLeftRadius: "80px",
                          }}
                        />
                        <Button
                          type="submit"
                          className="bg-brand-orange border-0 font-size-16 fw-bold ff-sora"
                          disabled={isSubmitting}
                          style={{
                            borderTopRightRadius: "80px",
                            borderBottomRightRadius: "80px",
                          }}
                        >
                          {isSubmitting ? "Searching..." : "Search"}
                        </Button>
                      </div>
                    </FormGroup>

                    {validation.touched.code && validation.errors.code && (
                      <div className="text-danger ff-sora">
                        {validation.errors.code}
                      </div>
                    )}
                  </Form>

                  {redeem?.pass?.name ? (
                    <>
                      <div className="my-2 d-flex justify-content-center">
                        <Pass
                          code={`Pass Id : ${redeem?.pass.id} , Pass Name : ${redeem?.pass.name} , Coin Price :  ${redeem?.pass.coinsPrice}, Duration :  ${redeem?.pass.duration}, Gym Name : ${redeem?.pass?.gym?.name}`}
                          name={redeem?.pass?.name}
                          price={redeem?.pass?.price * 10}
                          duration={redeem?.pass?.duration}
                          filter={
                            redeem?.pass?.duration === "oneday"
                              ? passDesign1
                              : redeem?.pass?.duration === "oneweek"
                              ? passDesign2
                              : redeem?.pass?.duration === "onemonth"
                              ? passDesign3
                              : null
                          }
                          address={redeem?.pass?.gym?.name}
                          createdAt={redeem?.pass?.createdAt}
                        />
                      </div>

                      <Button
                        style={{ maxWidth: "360px" }}
                        disabled={code}
                        className="custom-button bg-brand-orange rounded-pill font-size-16 fw-bold ff-sora"
                        onClick={() => handleRedeem(passId, gymId)}
                      >
                        {isLoading ? "Loading..." : "Confirm"}
                      </Button>
                    </>
                  ) : (
                    <div></div>
                  )}
                  <div className="mt-4  ff-sora text-center">
                    <p className="text-center pt-0 ff-sora font-size-16 fw-medium mt-0">
                      <Link to="/login" className="brand-orange">
                        Go Back
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default withRouter(RedeemPass);

RedeemPass.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
};
